<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("SUBSCRIPTIONS.ADD_SUBSCRIPTION") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <subscription-form
              :loading="loading"
              :subscriptionData="subscription"
              :formErrors="formErrors"
              @subscriptionSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultSubscription from "./defaultSubscription";
import SubscriptionForm from "./partials/SubscriptionForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    SubscriptionForm,
  },

  mixins: [alertLeave],

  data() {
    const subscription = cloneDeep(defaultSubscription);
    return {
      subscription: subscription,
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    goBack() {
      this.$router.push({ name: "List Subscriptions" });
    },

    viewSubscription(subscription) {
      this.alertLeave = false;
      this.$router.push({
        name: "View Subscription",
        params: { id: subscription.id },
      });
    },

    async handleSubmit(subscription) {
      this.loading = true;

      const subscriptionData = cloneDeep(subscription);
      delete subscriptionData.id;

      try {
        await this.$store.dispatch("subscriptions/add", subscriptionData);
        this.$notify({
          type: "success",
          message: this.$t("SUBSCRIPTIONS.SUBSCRIPTION_ADDED"),
        });
        const subscription = await this.$store.getters[
          "subscriptions/subscription"
        ];
        this.viewSubscription(subscription);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
